module.exports = __webpack_public_path__ + "img/controller.553e0e80.svg";